import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import 'react-dynamic-swiper/lib/styles.css'
import styles from './FeaturesLightboxList.module.css'

const query = graphql`
  query {
    allFile(filter: { relativePath: { regex: "/features/" } }) {
      nodes {
        relativePath
        childImageSharp {
          fluid(quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`

const LightboxImage = ({ fluid }) => {
  if (!fluid) return null

  return (
    <Img
      fluid={fluid}
      imgStyle={{
        objectFit: 'contain'
      }}
      style={{
        height: 'inherit',
        margin: '3px',
        filter: 'drop-shadow(0px 0px 3px rgba(0,0,0,0.3))'
      }}
    />
  )
}

const FeatureImagesList = props => {
  const data = useStaticQuery(query)
  const images = data.allFile.nodes

  const compare2ImgPath = (a,b) => a.slice(-5)[0] > b.slice(-5)[0] ? 1 : -1
  images.sort((a, b) => (compare2ImgPath(a.relativePath, b.relativePath)))
  console.log('images', images)

  return (
    <ul className={styles.list}>
      {images.map((image, index) => (
        <li key={index} className={styles.listItem}>
          <LightboxImage fluid={image.childImageSharp.fluid} />
        </li>
      ))}
    </ul>
  )
}

export default FeatureImagesList
